import ShareSVG from "../icons/share.svg";
import { useTranslations } from "../providers/TranslationsProvider";
import { PlayerControlButtonComponent } from "./PlayerControlButton";

export const ShareButton = ({ onClick }: { onClick: () => void }) => {
  const translations = useTranslations();
  return (
    <PlayerControlButtonComponent
      aria-label={translations(
        "player__a11y__voice_over_open_share_menu_button"
      )}
      onClick={onClick}
      Icon={<ShareSVG />}
      interactive
      hoverText={translations("player__a11y__hover_label_share_button")}
    />
  );
};
